export default "__VITE_PUBLIC_ASSET__0ffd932d__"